import { createInjectionKey as o } from "./ghl-ui.es896.js";
const e = o("n-dropdown-menu"), d = o("n-dropdown"), t = o("n-dropdown-option");
export {
  d as dropdownInjectionKey,
  e as dropdownMenuInjectionKey,
  t as dropdownOptionInjectionKey
};
